import type { MentionCandidate } from '@/hooks/apiHooks';
import type { Meta } from '@/types/legacyApi';

/** 한 검색어로 지금까지 불러온 멘션 후보. */
export type MentionPage = {
  query: string;
  currentPage: number;
  endPage: number;
  candidates: MentionCandidate[];
};

/** meta 가 없는 응답(서버 페이지네이션 적용 전)은 그 페이지가 마지막인 것으로 본다. */
const resolveEndPage = (
  requestedPage: number,
  data: MentionCandidate[],
  meta?: Meta,
) => (meta && data.length > 0 ? meta.endPage : requestedPage);

export const createMentionPage = (
  query: string,
  data: MentionCandidate[],
  meta?: Meta,
): MentionPage => ({
  query,
  currentPage: 1,
  endPage: resolveEndPage(1, data, meta),
  candidates: data,
});

export const hasNextMentionPage = (page: MentionPage) =>
  page.currentPage < page.endPage;

/**
 * 다음 페이지를 이어 붙인다. 페이지를 넘기는 사이 서버 데이터가 바뀌어 같은 사람이
 * 다시 와도 목록에는 한 번만 남긴다(메뉴 항목 key 가 겹치지 않게).
 */
export const appendMentionPage = (
  page: MentionPage,
  data: MentionCandidate[],
  meta?: Meta,
): MentionPage => {
  const nextPage = page.currentPage + 1;
  const loadedIds = new Set(page.candidates.map((c) => c.passportId));
  return {
    ...page,
    currentPage: nextPage,
    endPage: resolveEndPage(nextPage, data, meta),
    candidates: [
      ...page.candidates,
      ...data.filter((c) => !loadedIds.has(c.passportId)),
    ],
  };
};
